export default class HeypsterGif {
    constructor(gif) {
        const imgElement = document.createElement('img');
        imgElement.src = `https://heypster-gif.com/${gif.gif_mini}`;

        imgElement.setAttribute('data-gif_mini', `https://heypster-gif.com/${gif.gif_mini}`);
        imgElement.setAttribute('data-h264', `https://heypster-gif.com/${gif.h264}`);

        imgElement.addEventListener('click', () => {
            const event = new CustomEvent('heypsterGifClicked', {
                detail: {
                    gifMini: `https://heypster-gif.com/${gif.gif_mini}`,
                    h264: `https://heypster-gif.com/${gif.h264}`
                },
            });
            window.dispatchEvent(event);
        });

        return imgElement;
    }
}
